module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(!_vm.loading) ? _c('span', [_c('p', [_vm._v("\n      Here are some information about the device you are about to configure:\n    ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._m(0), _vm._v(" "), _c('b', [_vm._v("Hardware device ID:")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-dark"
  }, [_vm._v(_vm._s(_vm.apiResponse.hardware_device_id))])]), _vm._v(" "), _c('li', [_vm._m(1), _vm._v(" "), _c('b', [_vm._v("Homie for ESP8266 version:")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-dark"
  }, [_vm._v(_vm._s(_vm.apiResponse.homie_esp8266_version))])]), _vm._v(" "), _c('li', [_vm._m(2), _vm._v(" "), _c('b', [_vm._v("Firmware")]), _vm._v(" "), _c('ul', [_c('li', [_c('b', [_vm._v("Name:")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-dark"
  }, [_vm._v(_vm._s(_vm.apiResponse.firmware.name))])]), _vm._v(" "), _c('li', [_c('b', [_vm._v("Version:")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-dark"
  }, [_vm._v(_vm._s(_vm.apiResponse.firmware.version))])])])]), _vm._v(" "), _c('li', [_vm._m(3), _vm._v(" "), _c('b', [_vm._v("Nodes:")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.apiResponse.nodes), function(node) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(node.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(node.type))])])
  }))])])]), _vm._v(" "), _c('a', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.sendDone
    }
  }, [_vm._v("Next")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-hashtag"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-tag"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-font"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-cubes"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-hashtag"
  })]), _vm._v(" ID")]), _vm._v(" "), _c('th', [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-link"
  })]), _vm._v(" Type")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ec44bfe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/Info.vue
// module id = 54
// module chunks = 0